export { default } from "./ReadAloudSpeedControl";
